import { Outlet } from 'react-router-dom'

const Committees = () => {
    return (
        <>
            <Outlet />
        </>
    )
}

export default Committees
